import { baseApi } from './baseApi';
import { parseSignRequest } from '../parsers/agreement.parsers';

export const agreementApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createAgreementSignRequest: builder.mutation({
      query: () => ({
        url: 'api/agreements/sign-request',
        method: 'POST',
      }),
      transformResponse: parseSignRequest,
    }),
  }),
});

export const {
  useCreateAgreementSignRequestMutation,
} = agreementApi;
